import { useContext } from 'react';
import { NotificationContext } from './NotificationProvider';

function useNotification() {
  const { notification, pushNotification, popNotification } = useContext(NotificationContext);
  return { notification, pushNotification, popNotification };
}

export default useNotification;
